var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doc"},[(_vm.screen > 434)?_c('doc-pc',{staticClass:"doc-pc"}):(_vm.screen > 0 && _vm.screen <= 434)?_c('doc-mobile',{staticClass:"doc-mobile"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }